import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasViewed.meta';

export type UseTrackCanvasViewedParams = {
  canvas_id: string;
  viewer_role: 'owner' | 'workspace_member' | 'anonymous';
  board_id?: string;
  viewed_from?:
    | 'board'
    | 'recent_canvases'
    | 'my_canvases'
    | 'all_canvases'
    | 'shared_link'
    | 'asset_modal_edit_button'
    | 'asset_context_menu'
    | 'asset_modal_quick_tools'
    | 'asset_modal_versions_menu'
    | 'asset_modal_video_editor'
    | 'board_context_menu'
    | 'asset_hover'
    | 'asset_multi_select'
    | 'asset_selection_bar'
    | 'announcement';
};

export const useTrackCanvasViewed = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasViewed = useCallback(
    (params: UseTrackCanvasViewedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasViewed };
};
